export default "__VITE_ASSET__DDMDTO9m__"